export enum UserRole {
  ADMIN = "admin",
  MANAGER = "manager",
  OWNER = "owner",
  AGENT = "agent",
  GUEST = "guest"
}

export enum UserStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  INACTIVE = "inactive"
}

export enum PropertyStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending"
}

export enum BookingStatus {
  TEMPORARY = "temporary", // Temporary booking waiting for payment
  PENDING = "pending",
  CONFIRMED = "confirmed",
  COMPLETED = "completed",
  CANCELLED = "cancelled"
}

export interface User {
  id: number;
  username: string;
  email: string;
  fullName: string;
  phone: string | null;
  role: string;
  status: string;
  createdAt: Date;
  stripeAccountId: string | null;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  globalMarkupPercentage: number | null;
  companyName: string | null;
  country: string | null;
  idDocumentUrl: string | null;
  verificationNotes: string | null;
  rejectionReason: string | null;
  bankName: string | null;
  accountName: string | null;
  ibanNumber: string | null;
  swiftCode: string | null;
  totalEarnings: number;
  pendingEarnings: number;
  paidEarnings: number;
  lastPayout: Date | null;
  googleId: string | null;
}

export interface LoginCredentials {
  username: string;
  password: string;
}